import { atomWithReset } from 'jotai/utils';
import { ClickPosition } from '~/utils/click-position';

interface SimpleCtaModalProps {
  body: string;

  currentPosition: ClickPosition;
  pageClickId?: string;

  handleClickConfirm: () => void;
  handleClickCancel?: () => void;
}

export const $SimpleCTAModalShow = atomWithReset<SimpleCtaModalProps | false>(false);
